export const classesColumns = [
  'className',
  'classBegins',
  'classEnds',
  'weekDay',
  'attendance',
  'maximumNumberOfParticipants',
  'classAttendancePercentage',
  'trainerName',
  'newMembership',
  'onHoldLength',
];
